<!-- footer start -->
<footer class="agency bg-footer" id="footer">
    <div class="container">
        <div class="row">
            <div class="col-sm-3">
                <div class="d-flex align-items-end">
                    <a href="/"><img src="assets/images/logo/logo-footer.png" alt="Custom Solutions Logo Footer"
                            id="footerImg" loading="lazy"></a>
                </div>

            </div>
            <div class="col-sm-4">
                <h1 class="text-white">{{'FOOTER.header' | translate}}</h1>
                <div class="contact-details m-t-105">
                    <h6 class="contact-sub-text text-white"><i aria-hidden="true"
                            class="fa fa-envelope m-r-15"></i><span>sales</span>@customsolutions.info</h6>
                    <h6 class="contact-sub-text text-white"><i aria-hidden="true"
                            class="fa fa-envelope m-r-15"></i><span>info</span>@customsolutions.info</h6>
                    <h6 class="contact-sub-text text-white lh25">
                        <i aria-hidden="true" class="fa fa-map-marker m-r-20"></i>{{'FOOTER.address' | translate}}<br>
                    </h6>
                </div>
            </div>
            <div class="col-sm-5">
                <h1 class="text-white text-center">{{'FOOTER.Feedback.header' | translate}}</h1>
                <div class="form form-footer m-t-95">
                    <form #myForm [formGroup]="firstFormGroup" (ngSubmit)="onSubmit(myForm)" class="row">
                        <div class="col-12">
                            <div class="form-group">
                                <textarea class="form-control" rows="5" placeholder="{{'FOOTER.Feedback.Message placeholder' | translate}}" name="text"
                                    formControlName="aboutCtrl" aria-label="textarea-about"></textarea>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group">
                                <input type="email" placeholder="{{'FOOTER.Feedback.Email placeholder' | translate}}" formControlName="emailCtrl"
                                    aria-label="input-email">
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group">
                                <input type="text" formControlName="nameCtrl" placeholder="{{'FOOTER.Feedback.Name placeholder' | translate}}"
                                    aria-label="input-name">
                            </div>
                        </div>
                        <div class="col-sm-12 d-flex justify-content-center m-b-25" id="hide-captcha">
                            <re-captcha formControlName="captchaCtrl" siteKey={{siteKey}}>
                            </re-captcha>
                        </div>
                        <div class="form-group booking">
                            <button class="btn btn-default primary-btn m-0-auto bg-black p-l-r-80 button-sound"
                                type="submit" [disabled]="firstFormGroup.invalid">
                                {{'FOOTER.Feedback.Submit' | translate}}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
    <!--<div class="d-flex justify-content-center m-b-10 m-t-10">
        <div class="footer_pay">
            <img class="footer_pay_item--mc" src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/2a/Mastercard-logo.svg/1158px-Mastercard-logo.svg.png"/>
            <img class="footer_pay_item--visa" src="https://cdn.iconscout.com/icon/free/png-256/visa-credit-card-1822954-1547549.png"/>
            <img class="footer_pay_item--pm" src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/c4/Portmone_logo.svg/768px-Portmone_logo.svg.png?20210211105729"/>
        </div>
    </div>
    <div class="text-center">
        <a [routerLink]="policyLink"><h6 class="text-white copyright"><span>{{'FOOTER.Feedback.Privacy policy' | translate}}</span></h6></a>
    </div>-->
    <div class="d-flex justify-content-center m-b-10 m-t-10">
        <div class="addthis_inline_follow_toolbox"></div>
    </div>
    <div class="text-center">
        <h6 class="text-white copyright"><span>Custom Solutions</span> &copy; 2020</h6>
    </div>
</footer>
<!-- footer end -->
<app-tap-to-top></app-tap-to-top>